import React, {useEffect} from 'react'
import './leaveCard.css'
import { Link } from 'react-router-dom'
import { leaveBalance } from '../../api/leaveApi'
import { useSelector, useDispatch } from 'react-redux'
import { handleBalance } from '../../state/leaveSlice'

const LeaveCard = () => {
    const {user} = useSelector((state)=> state.user)
    const {balance} = useSelector((state)=> state.leave)
    const dispatch = useDispatch()

    const fetchLeaveRequest = async ()=>{
        try{
            const res = await leaveBalance(user?.token)
            dispatch(handleBalance(res?.data))
        }catch(error){
            console.log(error)
        }
    }
        
    useEffect(()=>{
        fetchLeaveRequest()
    },[])

  return (
    <div className='leave__card'>
        <h4 className="leave__card-title">
            Your Leave
        </h4>

        <div className="leave__card-content">
            <div className="leave__card-list">
                {
                    balance?.map((item)=>(
                        <>
                            <div className="leave__card-item">
                                <h4 className="leave__card-count">
                                    {item?.annualLeave - 20}
                                </h4>
                                <p className="leave__card-name">Leave Taken</p>
                            </div>
                            <span></span>
                            <div className="leave__card-item">
                                <h4 className="leave__card-count">
                                    {item?.annualLeave}
                                </h4>
                                <p className="leave__card-name">Remaining</p>
                            </div>
                        </>
                    ))
                }
            </div>
            <Link to={'/leave_request'} className='leave__card-link button'>Apply Leave</Link>
        </div>
    </div>
  )
}

export default LeaveCard